import { Supplier } from "@/types/supplier";
import { Space, Switch, Tooltip } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ColumnsProps } from "@/components/table";
import { ColumnsType } from "antd/es/table";

type GetColumnsProps = ColumnsProps<Supplier> & {
  onToggleActive?: (id: string, isActive: boolean) => void;
  onToggleReview?: (id: string, inReview: boolean) => void;
};

export const getColumns = ({
  onEdit,
  onToggleActive,
  onToggleReview,
  filterOptions,
  filterValues,
  getSortOrder,
}: GetColumnsProps): ColumnsType<Supplier> => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: true,
    sortOrder: getSortOrder?.("name"),
    filters: filterOptions?.name,
    filterSearch: true,
    filteredValue: filterValues?.name || null,
  },
  {
    title: "Contact Person",
    dataIndex: "contact_person",
    key: "contact_person",
    sorter: true,
    sortOrder: getSortOrder?.("contact_person"),
    filters: filterOptions?.contact_person,
    filterSearch: true,
    filteredValue: filterValues?.contact_person || null,
    render: (contact_person: string) => contact_person || "-",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    sorter: true,
    sortOrder: getSortOrder?.("email"),
    filters: filterOptions?.email,
    filterSearch: true,
    filteredValue: filterValues?.email || null,
    render: (email: string) => email || "-",
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
    sorter: true,
    sortOrder: getSortOrder?.("phone"),
    filters: filterOptions?.phone,
    filterSearch: true,
    filteredValue: filterValues?.phone || null,
    render: (phone: string) => phone || "-",
  },
  {
    title: "Active",
    dataIndex: "is_active",
    key: "is_active",
    sorter: true,
    sortOrder: getSortOrder?.("is_active"),
    render: (isActive: boolean, record: Supplier) => (
      <Switch
        checked={isActive}
        onChange={(checked) => onToggleActive?.(record.id, checked)}
      />
    ),
  },
  {
    title: "Reviewed",
    dataIndex: "is_reviewed",
    key: "is_reviewed",
    sorter: true,
    sortOrder: getSortOrder?.("is_reviewed"),
    render: (isReviewed: boolean, record: Supplier) => (
      <Switch
        checked={isReviewed}
        onChange={(checked) => onToggleReview?.(record.id, checked)}
      />
    ),
  },
  {
    title: "Actions",
    key: "actions",
    width: 100,
    render: (_: any, record: Supplier) => (
      <Space size="small">
        <Tooltip title="Edit">
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => onEdit?.(record)}
            size="small"
          />
        </Tooltip>
      </Space>
    ),
  },
];
